import React, { useState } from "react";
import {
    Col,
    Form,
    Row,
    Card,
    Tooltip,
    OverlayTrigger,
} from "react-bootstrap";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCog,
    faExclamationCircle,
    faTabletScreenButton
} from "@fortawesome/free-solid-svg-icons";
import {
    HelpTooltip, redirectURL
} from "../../assets/functions.js";
import DropzoneComponent from "../Dropzone.js";
import { domainConfig } from "../../config.js";
import PopoverPicker from "../PopoverPicker.js";
import { BackgroundFormComponent } from '../../components/Applications'

const WordsBoard = ({
    fonts,
    handleChange,
    values,
    setFieldValue,
    errors,
    touched,
    handlePreviewSuccess,
    handlePreviewError,
}) => {
    const [props, setProps] = useState({
        backgroundColor: values.json.apresentation?.textSide?.background?.color,
        textColor: values.json.apresentation?.textSide?.textColor
    });

    return (
        <>
            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">Definições</h5>
            </Form.Group>
            <Row className="mx-0 mb-3">
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        type="text"
                        name="titulo"
                        value={values.titulo}
                        onChange={handleChange}
                        isInvalid={!!errors.titulo}
                        isValid={touched.titulo && !errors.titulo}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.titulo}
                    </Form.Control.Feedback>
                </Form.Group>
                <p className="text-start fw-bold mb-2 mt-3">Mensagens</p>
                <Form.Group
                    as={Col}
                    md={3}
                    className="mb-3"
                >
                    <Form.Label>Limite por participante</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.messageLimit"
                        step={1}
                        value={values.json.messageLimit}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.messageLimit}
                        isValid={touched.json?.messageLimit && !errors.json?.messageLimit}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.messageLimit}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    as={Col}
                    sm="12" >
                    <Form.Check
                        checked={values.json.autoApproval ? true : false}
                        type="checkbox"
                        name="json.autoApproval"
                        label="Aprovar mensagens automaticamente"
                        onChange={(e) => {
                            setFieldValue(
                                "json.autoApproval",
                                values.json.autoApproval ? false : true
                            );
                        }}
                    />
                    <Form.Check
                        className="w-auto mb-0"
                        checked={values.json.selectWords?.status ? true : false}
                        type="checkbox"
                        name="json.selectWords.status"
                        label="Usar palavras pré-definidas"
                        onChange={(e) => {
                            setFieldValue(
                                "json.selectWords.status",
                                values.json.selectWords?.status ? false : true
                            );
                        }}
                    />
                    <div className="border p-3 mt-2 mb-3">
                        <Row className="mx-0">
                            {values.json.selectWords?.status ? (
                                <Form.Group
                                    as={Col}
                                    md={12}
                                    className="mb-3"
                                >
                                    <Form.Label>Palavras disponíveis</Form.Label>
                                    <CreatableSelect
                                        isMulti
                                        name="json.selectWords.options"
                                        options={values.json.selectWords?.options?.map(option => ({
                                            value: option,
                                            label: option
                                        })) || []}
                                        value={values.json.selectWords?.options?.map(option => ({
                                            value: option,
                                            label: option
                                        })) || []}
                                        onChange={(selectedOptions) => {
                                            const optionsArray = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                            setFieldValue('json.selectWords.options', optionsArray);
                                        }}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                padding: 5,
                                            }),
                                        }}
                                        placeholder="Digite e pressione Enter para adicionar palavras..."
                                        noOptionsMessage={() => "Digite para adicionar uma nova palavra"}
                                        formatCreateLabel={(inputValue) => `Adicionar "${inputValue}"`}
                                    />
                                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.json?.selectWords?.options}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            ) : (
                                <>
                                    <Form.Group
                                        as={Col}
                                        md={3}
                                        className="mb-3"
                                    >
                                        <Form.Label>Máximo de caracteres</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="json.maxlength"
                                            step={"10"}
                                            value={values.json.maxlength}
                                            onChange={handleChange}
                                            isInvalid={!!errors.json?.maxlength}
                                            isValid={touched.json?.maxlength && !errors.json?.maxlength}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.json?.maxlength}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        md={3}
                                        className="mb-3"
                                    >
                                        <Form.Label>Mínimo de caracteres</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="json.minlength"
                                            step={"10"}
                                            value={values.json.minlength}
                                            onChange={handleChange}
                                            isInvalid={!!errors.json?.minlength}
                                            isValid={touched.json?.minlength && !errors.json?.minlength}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.json?.minlength}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </>
                            )}
                            <Form.Group
                                as={Col}
                                md={3}
                                className="mb-3"
                            >
                                <Form.Label>Qnt. de palavra por mensagem</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="json.maxMessagePerLimit"
                                    step={1}
                                    value={values.json.maxMessagePerLimit}
                                    onChange={handleChange}
                                    isInvalid={!!errors.json?.maxMessagePerLimit}
                                    isValid={touched.json?.maxMessagePerLimit && !errors.json?.maxMessagePerLimit}
                                />
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.maxMessagePerLimit}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                    </div>
                </Form.Group>
            </Row>

            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">
                    Participante
                </h5>
            </Form.Group>
            <Row className="mx-0 mb-3">
                <p className="text-start fw-bold mb-2"><FontAwesomeIcon
                    icon={faTabletScreenButton}
                    className="me-1"
                />Tela inicial</p>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        as="textarea"
                        name="json.title.value"
                        value={values.json.title.value}
                        onChange={(e) => {
                            if (e.target.value === '') {
                                setFieldValue("json.title.status", false);
                            } else {
                                setFieldValue("json.title.status", true);
                            }
                            setFieldValue("json.title.value", e.target.value);
                        }}
                        isInvalid={!!errors?.json?.title?.value}
                        isValid={touched?.json?.title?.value && !errors.json?.title?.value}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.title?.value}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                        as="textarea"
                        name="json.description.value"
                        value={values.json.description.value}
                        onChange={(e) => {
                            if (e.target.value === '') {
                                setFieldValue("json.description.status", false);
                            } else {
                                setFieldValue("json.description.status", true);
                            }
                            setFieldValue("json.description.value", e.target.value);
                        }}
                        isInvalid={!!errors?.json?.description?.value}
                        isValid={touched?.json?.description?.value && !errors.json?.description?.value}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.description?.value}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Check
                        className="w-auto"
                        checked={values.json.showMessageHistory ? true : false}
                        type="checkbox"
                        name="json.showMessageHistory"
                        label="Participante pode ver histórico de mensagens"
                        onChange={(e) => {
                            setFieldValue(
                                "json.showMessageHistory",
                                values.json.showMessageHistory ? false : true
                            );
                        }}
                    />
                    <Form.Check
                        className="w-auto"
                        checked={values.json.deleteHistory ? true : false}
                        type="checkbox"
                        name="json.deleteHistory"
                        label="Habilitar exclusão de mensagem pelo usuário"
                        onChange={(e) => {
                            setFieldValue(
                                "json.deleteHistory",
                                values.json.deleteHistory ? false : true
                            );
                        }}
                    />
                    <Form.Check
                        className="w-auto"
                        checked={values.json.userFeedback ? true : false}
                        type="checkbox"
                        name="json.userFeedback"
                        label="Mostrar status da mensagem para o participante"
                        onChange={(e) => {
                            setFieldValue(
                                "json.userFeedback",
                                values.json.userFeedback ? false : true
                            );
                        }}
                    />
                </Form.Group>
            </Row>
            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">Modo apresentação</h5>
            </Form.Group>
            <Row className="mx-0">
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12"

                >
                    <Form.Label>Título</Form.Label>
                    <Form.Control
                        as="textarea"
                        name="json.apresentation.title.value"
                        value={values.json.apresentation?.title?.value}
                        onChange={(e) => {
                            if (e.target.value === '') {
                                setFieldValue("json.apresentation.title.status", false);
                            } else {
                                setFieldValue("json.apresentation.title.status", true);
                            }
                            setFieldValue("json.apresentation.title.value", e.target.value);
                        }}
                        isInvalid={!!errors?.json?.apresentation?.title?.value}
                        isValid={touched?.json?.apresentation?.title?.value && !errors?.json?.apresentation?.title?.value}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.title?.value}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    as={Col}
                    md={3}
                    className="mb-3"
                >
                    <Form.Label>Tamanho fonte (M) (rem)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.h5"
                        step={"0.01"}
                        value={values.json.apresentation?.textSide?.h5}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.h5}
                        isValid={touched.json?.apresentation?.textSide?.h5 && !errors.json?.apresentation?.textSide?.h5}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.h5}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                    as={Col}
                    md={3}
                    className="mb-3"
                >
                    <Form.Label>Tamanho fonte (P) (rem)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.p"
                        step={"0.01"}
                        value={values.json.apresentation?.textSide?.p}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.p}
                        isValid={touched.json?.apresentation?.textSide?.p && !errors.json?.apresentation?.textSide?.p}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.p}
                    </Form.Control.Feedback>
                </Form.Group>
                <div className="col-md-3 mb-3">
                    <Form.Label>Cor do texto</Form.Label>
                    <div className={`d-flex justify-content-start align-items-center ${errors?.json?.apresentation?.textSide?.textColor ? 'is-invalid' : ''}`}>
                        <Form.Control
                            type="hidden"
                            name="json.apresentation.textSide.textColor"
                            value={values.json?.apresentation?.textSide?.textColor}
                            isInvalid={!!errors?.json?.apresentation?.textSide?.textColor}
                            isValid={touched?.json?.apresentation?.textSide?.textColor && !errors?.json?.apresentation?.textSide?.textColor}
                        />
                        <PopoverPicker
                            color={props.textColor}
                            onChangeX={(e) => {
                                setFieldValue("json.apresentation.textSide.textColor", e);
                                setProps(prevState => ({
                                    ...prevState,
                                    textColor: e
                                }));
                            }}
                            classes={`me-1 picker ${errors?.json?.apresentation?.textSide?.textColor ? 'is-invalid' : ''}`}
                        />
                    </div>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors?.json?.apresentation?.textSide?.textColor ? errors?.json?.apresentation?.textSide?.textColor : ''}
                    </Form.Control.Feedback>
                </div>
            </Row>

            <Row className="mx-0 mb-3">
                <Form.Group
                    as={Col}
                    md="6">
                    <Form.Label>Plano de fundo {values.json.apresentation.textSide.background.type === 'color' && <OverlayTrigger
                        overlay={<Tooltip><b>Exemplo: </b>linear-gradient(90deg,rgba(42, 123, 155, 1) 0%, rgba(87, 199, 133, 1) 50%, rgba(237, 221, 83, 1) 100%)</Tooltip>}
                    >
                        <span className="badge text-dark bg-light cursor-pointer ms-1" onClick={() => redirectURL(true, 'https://cssgradient.io/')}>CSS Gradient</span>
                    </OverlayTrigger>}</Form.Label>
                    <Form.Select
                        name="json.apresentation.textSide.background.type"
                        onChange={handleChange}
                        value={values.json.apresentation.textSide.background.type}
                        isInvalid={!!errors.json?.apresentation?.textSide?.background?.type}
                        isValid={touched.json?.apresentation?.textSide?.background?.type && !errors.json?.apresentation?.textSide?.background?.type}>
                        <option value={"color"}>
                            Cor
                        </option>
                        <option value={"image"}>
                            Imagem
                        </option>
                        <option value={"video"}>
                            Vídeo
                        </option>
                    </Form.Select>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">{errors.json?.apresentation?.textSide?.background?.type}</Form.Control.Feedback>
                </Form.Group>
            </Row>
            {values.json?.apresentation?.textSide?.background?.type !== 'color' ? <Row className="mb-3 mx-0">
                <BackgroundFormComponent touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} handlePreviewSuccess={handlePreviewSuccess} handlePreviewError={handlePreviewError}></BackgroundFormComponent>
            </Row> :
                <Row className="mx-0 mb-3">
                    <div className="col-md-3 mb-3">
                        <div className={`d-flex justify-content-start align-items-center ${errors?.json?.apresentation?.textSide?.background?.color ? 'is-invalid' : ''}`}>
                            <Form.Control
                                type="hidden"
                                name="json.apresentation.textSide.background.color"
                                value={values.json.apresentation.textSide.background.color}
                                isInvalid={!!errors?.json?.apresentation?.textSide?.background?.color}
                                isValid={touched?.json?.apresentation?.textSide?.background?.color && !errors?.json?.apresentation?.textSide?.background?.color}
                            />
                            <PopoverPicker
                                color={props.backgroundColor}
                                onChangeX={(e) => {
                                    setFieldValue("json.apresentation.textSide.background.color", e);
                                    setProps(prevState => ({
                                        ...prevState,
                                        backgroundColor: e
                                    }));
                                }}
                                classes={`me-1 picker ${errors?.json?.apresentation?.textSide?.background?.color ? 'is-invalid' : ''}`}
                            />
                        </div>
                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">
                            {errors?.json?.apresentation?.textSide?.background?.color ? errors?.json?.apresentation?.textSide?.background?.color : ''}
                        </Form.Control.Feedback>
                    </div>
                </Row>
            }

            <Row className="mx-0">
                <Form.Group as={Col} sm={4} className='mb-3'>
                    <Form.Label>Largura da logomarca (px)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.configs.logoSize"
                        value={values.json.apresentation.configs.logoSize}
                        onChange={(e) => {
                            handleChange(e);
                        }}
                        isInvalid={!!errors.json?.apresentation?.configs?.logoSize}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.configs?.logoSize}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row >

            <Row className="mx-0">
                <Form.Group
                    className="mb-3"
                    as={Col}
                    md="6"

                >
                    <Form.Label>Tipo de layout</Form.Label>
                    <Form.Select
                        onChange={(e) => {
                            if (e.target.value === "2") {
                                setFieldValue(
                                    "json.apresentation.imageSide.value", 40
                                );
                                setFieldValue(
                                    "json.apresentation.textSide.value", 60
                                );
                            } else {
                                setFieldValue(
                                    "json.apresentation.imageSide.value", 0
                                );
                                setFieldValue(
                                    "json.apresentation.textSide.value", 100
                                );
                            }
                        }}
                        value={values.json.apresentation?.imageSide?.value && values.json.apresentation?.imageSide?.value > 0 ? 2 : 1}>
                        <option value={1}>
                            Simples
                        </option>
                        <option value={2}>
                            Com banner
                        </option>
                    </Form.Select>
                </Form.Group>
            </Row>
            {
                values.json.apresentation.imageSide?.value > 0 &&
                <>
                    <Row className="mx-0">
                        <Form.Group
                            as={Col}
                            md="3"
                            className="mb-3"
                        >
                            <Form.Label>Tamanho do banner (%)</Form.Label>
                            <Form.Control
                                type="number"
                                name="json.apresentation.imageSide.value"
                                value={values.json.apresentation?.imageSide?.value}
                                onChange={(e) => {
                                    if (e.target.value === undefined || e.target.value === '') {
                                        e.target.value = 0
                                    }
                                    let textSideValue = 100 - e.target.value
                                    setFieldValue("json.apresentation.imageSide.value", e.target.value);
                                    setFieldValue("json.apresentation.textSide.value", textSideValue);
                                }}
                                isInvalid={!!errors.json?.apresentation?.imageSide?.value}
                                isValid={touched.json?.apresentation?.imageSide?.value && !errors.json?.apresentation?.imageSide?.value}
                            />
                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                            <Form.Control.Feedback type="invalid">
                                {errors.json?.apresentation?.imageSide?.value}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group
                            as={Col}
                            md="3"
                            className="mb-3"

                        >
                            <Form.Label>Posição</Form.Label>
                            <Form.Select
                                onChange={handleChange}
                                name="json.apresentation.imageSide.position"
                                value={values.json.apresentation?.imageSide?.position}>
                                <option value={'start'}>
                                    Esquerda
                                </option>
                                <option value={'end'}>
                                    Direita
                                </option>
                            </Form.Select>
                        </Form.Group>
                    </Row>
                    <Row className="mx-0 mb-3">
                        <Form.Group
                            as={Col}
                            md="6">
                            <Card className="mb-3">
                                <Card.Body>
                                    <div className="text-center mb-3">
                                        <div className="d-flex justify-content-center mb-3">
                                            <Form.Label>Banner</Form.Label>
                                        </div>
                                    </div>
                                    <Form.Control
                                        type="hidden"
                                        name="json.apresentation.imageSide.background"
                                        value={values.json.apresentation?.imageSide?.background}
                                        onChange={handleChange}
                                        isInvalid={!!errors?.json?.apresentation?.imageSide?.background}
                                        isValid={touched?.json?.apresentation?.imageSide?.background && !errors?.json?.apresentation?.imageSide?.background}
                                    />
                                    <div className="imagesUpload">
                                        <img
                                            className={`h-100 img-thumbnail ${!!errors?.json?.apresentation?.imageSide?.background ? "is-invalid" : ""}`}
                                            src={
                                                values.json.apresentation?.imageSide?.background !== "" && values.json.apresentation?.imageSide?.background !== null
                                                    ? domainConfig.imageServer +
                                                    "/customizacao/" +
                                                    values.customizacao_id +
                                                    "/" +
                                                    values.json.apresentation?.imageSide?.background
                                                    : domainConfig.imageServer + "/empty-background.png"
                                            }
                                            alt="ImagemBase"
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors?.json?.apresentation?.imageSide?.background}
                                        </Form.Control.Feedback>
                                    </div>
                                    <DropzoneComponent
                                        className="mt-3 dropzoneComp"
                                        type="image"
                                        handlePreviewSuccess={handlePreviewSuccess}
                                        handlePreviewError={handlePreviewError}
                                        setFieldValue={setFieldValue}
                                        folder="customizacao"
                                        id={values.customizacao_id}
                                        field="json.apresentation.imageSide.background"
                                    />
                                </Card.Body>
                            </Card>
                        </Form.Group>
                    </Row>
                </>
            }
            <Row className="mx-0 mb-3">
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12">
                    <Form.Check
                        checked={values.json.apresentation?.showQRCode.status === true ? true : false}
                        type="checkbox"
                        name="json.apresentation.showQRCode.status"
                        label="Mostrar QRCode"
                        onChange={(e) => {
                            setFieldValue(
                                "json.apresentation.showQRCode.status",
                                values.json.apresentation.showQRCode?.status === true ? false : true
                            );
                        }}
                    />
                    {values.json.apresentation?.showQRCode?.status === true ? (
                        <Row>
                            <Form.Group
                                className="mb-3"
                                as={Col}
                                sm="4"
                            >
                                <Form.Label>Texto</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="json.apresentation.showQRCode.text"
                                    value={values.json.apresentation.showQRCode.text}
                                    onChange={handleChange}
                                    isInvalid={!!errors.apresentation?.showQRCode?.text}
                                    isValid={
                                        touched.json?.apresentation?.showQRCode?.text &&
                                        !errors.json?.apresentation?.showQRCode?.text
                                    }
                                />
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.apresentation?.showQRCode?.text}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                as={Col}
                                sm="4"

                            >
                                <Form.Label>URL<OverlayTrigger overlay={<Tooltip>Caso nenhuma URL seja fornecida o QRCode irá redirecionar o usuário ao evento</Tooltip>}>
                                    <HelpTooltip icon={faExclamationCircle} />
                                </OverlayTrigger></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="json.apresentation.showQRCode.link"
                                    value={values.json.apresentation.showQRCode.link}
                                    onChange={handleChange}
                                    isInvalid={!!errors.apresentation?.showQRCode?.link}
                                    isValid={
                                        touched.json?.apresentation?.showQRCode?.link &&
                                        !errors.json?.apresentation?.showQRCode?.link
                                    }
                                />
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.apresentation?.showQRCode?.link}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                as={Col}
                                sm="4"

                            >
                                <Form.Label>Posição Y</Form.Label>
                                <Form.Select
                                    onChange={(e) => {
                                        setFieldValue("json.apresentation.showQRCode.position.y", e.target.value);
                                    }}
                                    value={values.json.apresentation.showQRCode.position.y}>
                                    <option value={'top'}>
                                        Topo
                                    </option>
                                    <option value={'bottom'}>
                                        Fundo
                                    </option>
                                </Form.Select>
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.apresentation?.showQRCode?.position?.y}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                as={Col}
                                sm="4"

                            >
                                <Form.Label>Posição X</Form.Label>
                                <Form.Select
                                    onChange={(e) => {
                                        setFieldValue("json.apresentation.showQRCode.position.x", e.target.value);
                                    }}
                                    value={values.json.apresentation.showQRCode.position.x}>
                                    <option value={'left'}>
                                        Esquerda
                                    </option>
                                    <option value={'right'}>
                                        Direita
                                    </option>
                                </Form.Select>
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.apresentation?.showQRCode?.position?.x}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                    ) : (
                        ""
                    )}
                </Form.Group>
            </Row>
            <Form.Group as={Col} className="mb-3 mx-2">
                <h5 className="card-title mb-0"><FontAwesomeIcon
                    icon={faCog}
                    className="me-1"
                /> Configurações avançadas</h5>
                <hr className="mt-2"></hr>
            </Form.Group>
            <Row className="mx-0">
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Tempo de Exibição (s)
                        <OverlayTrigger overlay={<Tooltip>Tempo total que a nuvem de palavras fica visível antes de reiniciar o ciclo.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.displayTime"
                        value={values.json.apresentation?.textSide?.configs?.displayTime || 30}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.displayTime}
                        isValid={touched.json?.apresentation?.textSide?.configs?.displayTime && !errors.json?.apresentation?.textSide?.configs?.displayTime}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.displayTime}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Máximo de Palavras
                        <OverlayTrigger overlay={<Tooltip>O número máximo de palavras a serem exibidas na nuvem.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.maxWords"
                        value={values.json.apresentation?.textSide?.configs?.maxWords || 100}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.maxWords}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.maxWords}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} sm="12">
                    <Form.Check
                        type="checkbox"
                        label="Habilitar Tooltip nas Palavras"
                        name="json.apresentation.textSide.configs.enableTooltip"
                        checked={values.json.apresentation?.textSide?.configs?.enableTooltip || false}
                        onChange={(e) => {
                            setFieldValue(
                                "json.apresentation.textSide.configs.enableTooltip",
                                e.target.checked
                            );
                        }}
                    />
                    <Form.Check
                        className="w-auto mb-0"
                        checked={values.json.fallbackWords?.status ? true : false}
                        type="checkbox"
                        name="json.fallbackWords.status"
                        label="Usar palavras de preenchimento (fallback)"
                        onChange={(e) => {
                            setFieldValue(
                                "json.fallbackWords.status",
                                values.json.fallbackWords?.status ? false : true
                            );
                        }}
                    />
                    {values.json.fallbackWords?.status && (
                        <div className="border p-3 mt-2 mb-3">
                            <Form.Group as={Col} md={12} className="mb-3">
                                <Form.Label>Palavras de preenchimento</Form.Label>
                                <CreatableSelect
                                    isMulti
                                    name="json.fallbackWords.options"
                                    options={values.json.fallbackWords?.options?.map(option => ({
                                        value: option,
                                        label: option
                                    })) || []}
                                    value={values.json.fallbackWords?.options?.map(option => ({
                                        value: option,
                                        label: option
                                    })) || []}
                                    onChange={(selectedOptions) => {
                                        const optionsArray = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                        setFieldValue('json.fallbackWords.options', optionsArray);
                                    }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            padding: 5,
                                        }),
                                    }}
                                    placeholder="Digite e pressione Enter para adicionar..."
                                    noOptionsMessage={() => "Digite para adicionar uma nova palavra"}
                                    formatCreateLabel={(inputValue) => `Adicionar "${inputValue}"`}
                                />
                                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                    {errors.json?.fallbackWords?.options}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>
                    )}
                </Form.Group>

                {/* Aparência */}
                <Form.Group as={Col} sm="12" className="mt-3 mb-0">
                    <p className="text-start fw-bold mb-2">Layout</p>
                </Form.Group>
                <Form.Group
                    as={Col}
                    md={3}
                    className="mb-3">
                    <Form.Label>Fonte <span className="badge text-dark bg-light cursor-pointer ms-1" onClick={() => redirectURL(true, 'https://fonts.google.com/')}>Google fonts</span></Form.Label>
                    <Select
                        name="json.apresentation.textSide.fontFamily"
                        options={fonts}
                        value={fonts.find(
                            (option) => option.value === values.json.apresentation.textSide.fontFamily
                        )}
                        onChange={(selectedOption) => {
                            setFieldValue(
                                'json.apresentation.textSide.fontFamily', selectedOption.value
                            );
                        }}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                padding: 5,
                            }),
                        }}
                    />
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>Estilo da Fonte</Form.Label>
                    <Form.Select
                        name="json.apresentation.textSide.configs.fontStyle"
                        value={values.json.apresentation?.textSide?.configs?.fontStyle || 'normal'}
                        onChange={handleChange}
                    >
                        <option value="normal">normal</option>
                        <option value="italic">italic</option>
                        <option value="oblique">oblique</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>Tamanho fonte mínimo (px)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.fontSizeMin"
                        step={"0.01"}
                        value={values.json.apresentation?.textSide?.configs?.fontSizeMin || 30}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.fontSizeMin}
                        isValid={touched.json?.apresentation?.textSide?.configs?.fontSizeMin && !errors.json?.apresentation?.textSide?.configs?.fontSizeMin}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.fontSizeMin}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>Tamanho fonte máximo (px)</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.fontSizeMax"
                        step={"0.01"}
                        value={values.json.apresentation?.textSide?.configs?.fontSizeMax || 80}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.fontSizeMax}
                        isValid={touched.json?.apresentation?.textSide?.configs?.fontSizeMax && !errors.json?.apresentation?.textSide?.configs?.fontSizeMax}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.fontSizeMax}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>Espessura Mín. da Fonte</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.minFontWeight"
                        value={values.json.apresentation?.textSide?.configs?.minFontWeight || 400}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.minFontWeight}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.minFontWeight}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>Espessura Máx. da Fonte</Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.maxFontWeight"
                        value={values.json.apresentation?.textSide?.configs?.maxFontWeight || 700}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.maxFontWeight}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.maxFontWeight}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Rotação Mínima (graus)
                        <OverlayTrigger overlay={<Tooltip>O ângulo mínimo de rotação para as palavras.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.minRotation"
                        value={values.json.apresentation?.textSide?.configs?.minRotation || 0}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.minRotation}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.minRotation}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Rotação Máxima (graus)
                        <OverlayTrigger overlay={<Tooltip>O ângulo máximo de rotação para as palavras.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.maxRotation"
                        value={values.json.apresentation?.textSide?.configs?.maxRotation || 0}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.maxRotation}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.maxRotation}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} sm="12" className="mb-3">
                    <Form.Check
                        type="checkbox"
                        label={<span>Usar Gradientes<OverlayTrigger overlay={<Tooltip>Colore as palavras com gradientes SVG baseados nas cores de personalização do evento (cor primária e cor base do texto). Quando desativado, utiliza uma paleta fixa de 12 cores sólidas.</Tooltip>}><HelpTooltip icon={faExclamationCircle} /></OverlayTrigger></span>}
                        name="json.apresentation.textSide.configs.useGradients"
                        checked={values.json.apresentation?.textSide?.configs?.useGradients || false}
                        onChange={(e) => {
                            setFieldValue(
                                "json.apresentation.textSide.configs.useGradients",
                                e.target.checked
                            );
                        }}
                    />
                </Form.Group>

                {/* Layout e Animação */}
                <Form.Group as={Col} sm="12" className="mt-3 mb-0">
                    <p className="text-start fw-bold mb-2">Animação</p>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Tipo de Espiral
                        <OverlayTrigger overlay={<Tooltip>O algoritmo usado para posicionar as palavras. 'Archimedean' é mais compacto.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Select
                        name="json.apresentation.textSide.configs.spiral"
                        value={values.json.apresentation?.textSide?.configs?.spiral || 'archimedean'}
                        onChange={handleChange}
                    >
                        <option value="archimedean">archimedean</option>
                        <option value="rectangular">rectangular</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Transição CSS
                        <OverlayTrigger overlay={<Tooltip>A regra CSS para a animação de movimento das palavras.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="json.apresentation.textSide.configs.transition"
                        value={values.json.apresentation?.textSide?.configs?.transition || 'all 0.5s ease-out'}
                        onChange={handleChange}
                    />
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Espaçamento
                        <OverlayTrigger overlay={<Tooltip>Espaço extra ao redor de cada palavra para evitar sobreposição.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.padding"
                        value={values.json.apresentation?.textSide?.configs?.padding || 2}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.padding}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.padding}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Intervalo de Tempo
                        <OverlayTrigger overlay={<Tooltip>Intervalo entre tentativas de posicionamento. Valores menores são mais precisos mas mais lentos.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        step="0.1"
                        name="json.apresentation.textSide.configs.timeInterval"
                        value={values.json.apresentation?.textSide?.configs?.timeInterval || 1}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.timeInterval}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.timeInterval}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Atraso da Animação (ms)
                        <OverlayTrigger overlay={<Tooltip>Multiplicador para o efeito 'cascata' na entrada das palavras. Quanto maior, mais lenta a sequência.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.animationDurationMultiplier"
                        value={values.json.apresentation?.textSide?.configs?.animationDurationMultiplier || 50}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.animationDurationMultiplier}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.animationDurationMultiplier}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Atraso entre Grupos (ms)
                        <OverlayTrigger overlay={<Tooltip>Tempo de espera entre a exibição dos grupos de palavras (Grandes, Médias, Pequenas).</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.groupDelay"
                        value={values.json.apresentation?.textSide?.configs?.groupDelay || 500}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.groupDelay}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.groupDelay}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Duração do Zoom (ms)
                        <OverlayTrigger overlay={<Tooltip>Tempo da animação de zoom ao passar o mouse sobre uma palavra.</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        name="json.apresentation.textSide.configs.scaleDuration"
                        value={values.json.apresentation?.textSide?.configs?.scaleDuration || 300}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.scaleDuration}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.scaleDuration}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3} className="mb-3">
                    <Form.Label>
                        Tamanho do Zoom
                        <OverlayTrigger overlay={<Tooltip>Fator de escala ao passar o mouse (ex: 1.3 aumenta 30%).</Tooltip>}>
                            <HelpTooltip icon={faExclamationCircle} />
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        step="0.1"
                        name="json.apresentation.textSide.configs.scaleSize"
                        value={values.json.apresentation?.textSide?.configs?.scaleSize || 1.3}
                        onChange={handleChange}
                        isInvalid={!!errors.json?.apresentation?.textSide?.configs?.scaleSize}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.apresentation?.textSide?.configs?.scaleSize}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};

export default WordsBoard